import gql from 'graphql-tag';

export const gqlGetContributionsPartial = gql`
  query getContributions($where: String, $offset: Int, $limit: Int, $order: String) {
    getContributions(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        contributorId
        year
        periodId
        statusId
        submittedByUser
        isInvoiced
        invoiceFileId
        declarationDate
        isComplementary
        isCanceled
        releaseToErp
        totalItems
        totalWeight
        totalCost
        contributionBatteriesGroupId
        isComplementaryName
        contributor {
          id
          name
          vatNumber
        }
        contributionstate {
          id
          name
        }
        contributionperiod {
          id
          name
          contributionperiodgroup {
            id
            name
          }
        }
        contributionbatteriesgroup {
          id
          name
        }
        invoiceFile {
          id
          fileName
          mimeMediaType
          s3Key
        }
      }
      recordCount
    }
  }
`;

export const gqlGetContributions = gql`
  query getCntContributions($where: String, $offset: Int, $limit: Int, $order: String) {
    getCntContributions(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        contributorId
        year
        periodId
        statusId
        submittedByUser
        isInvoiced
        invoiceFileId
        creditInvoiceFileId
        declarationDate
        isCanceled
        releaseToErp
        totalCost
        totalQty
        totalWeight
        seriesId
        series {
          id
          name
        }
        contributor {
          id
          name
          vatNumber
        }
        contributionstate {
          id
          name
        }
        contributionperiod {
          id
          name
          enName
        }
        invoiceFile {
          id
          fileName
          mimeMediaType
          s3Key
        }
        creditInvoiceFile {
          id
          fileName
          mimeMediaType
          s3Key
        }
      }
      recordCount
    }
  }
`;

export const gqlGetContribution = gql`
  query getContributionById($id: Int) {
    getContributionById(id: $id) {
      id
      contributorId
      year
      periodId
      statusId
      invoiceFileId
      isInvoiced
      declarationDate
      isComplementary
      isComplementaryName
      isCanceled
      releaseToErp
      submittedByUser
      qty1
      qty2
      qty3
      qty4
      qty5
      qty6
      qty7
      qty8
      qty9
      qty10
      qty11
      qty12
      qty13
      qty14
      qty15
      qty16
      qty17
      qty18
      qty19
      qty20
      qty21
      qty22
      qty23
      qty24
      qty25
      qty26
      qty27
      qty28
      qty29
      qty30
      qty31
      itemPrice1
      itemPrice2
      itemPrice3
      itemPrice4
      itemPrice5
      itemPrice6
      itemPrice7
      itemPrice8
      itemPrice9
      itemPrice10
      itemPrice11
      itemPrice12
      itemPrice13
      itemPrice14
      itemPrice15
      itemPrice16
      itemPrice17
      itemPrice18
      itemPrice19
      itemPrice20
      itemPrice21
      itemPrice22
      itemPrice23
      itemPrice24
      itemPrice25
      itemPrice26
      itemPrice27
      itemPrice28
      itemPrice29
      itemPrice30
      itemPrice31
      itemWeight1
      itemWeight2
      itemWeight3
      itemWeight4
      itemWeight5
      itemWeight6
      itemWeight7
      itemWeight8
      itemWeight9
      itemWeight10
      itemWeight11
      itemWeight12
      itemWeight13
      itemWeight14
      itemWeight15
      itemWeight16
      itemWeight17
      itemWeight18
      itemWeight19
      itemWeight20
      itemWeight21
      itemWeight22
      itemWeight23
      itemWeight24
      itemWeight25
      itemWeight26
      itemWeight27
      itemWeight28
      itemWeight29
      itemWeight30
      itemWeight31
      price1
      price2
      price3
      price4
      price5
      price6
      price7
      price8
      price9
      price10
      price11
      price12
      price13
      price14
      price15
      price16
      price17
      price18
      price19
      price20
      price21
      price22
      price23
      price24
      price25
      price26
      price27
      price28
      price29
      price30
      price31
      weight1
      weight2
      weight3
      weight4
      weight5
      weight6
      weight7
      weight8
      weight9
      weight10
      weight11
      weight12
      weight13
      weight14
      weight15
      weight16
      weight17
      weight18
      weight19
      weight20
      weight21
      weight22
      weight23
      weight24
      weight25
      weight26
      weight27
      weight28
      weight29
      weight30
      weight31
      totalItems
      totalWeight
      totalCost
      contributionBatteriesGroupId
      contributor {
        id
        name
        addressLine1
        addressArea
        vatNumber
      }
      contributionstate {
        id
        name
      }
      contributionperiod {
        id
        name
        months
        periodStartDay
        periodStartMonth
        periodEndDay
        periodEndMonth
        periodEndYearAdd
      }
      invoiceFile {
        id
        fileName
        mimeMediaType
        s3Key
      }
      contributionbatteriesgroup {
        id
        name
      }
      firstDate
      lastDate
      firstUser
      lastUser
    }
  }
`;

export const gqlUpdateContribution = gql`
  mutation updateCntContribution($data: ContributionInput) {
    updateCntContribution(data: $data) {
      id
    }
  }
`;

export const gqlCreateContributionsForCurrentYear = gql`
  mutation createContributionsForCurrentYear {
    createContributionsForCurrentYear
  }
`;

type Int = number;
type String = string;
type Boolean = boolean;
type Float = number;
type DateTime = Date;
export class ContributionInput {
  id: Int;
  contributorId: Int;
  year: Int;
  periodId: Int;
  statusId: Int;
  submittedByUser: string;
  isInvoiced: boolean;
  releaseToErp: boolean;
  isCanceled: boolean;
  isComplementary: boolean;
  invoiceFileId: Int;
  declarationDate: DateTime;
  qty1: Int;
  qty2: Int;
  qty3: Int;
  qty4: Int;
  qty5: Int;
  qty6: Int;
  qty7: Int;
  qty8: Int;
  qty9: Int;
  qty10: Int;
  qty11: Int;
  qty12: Int;
  qty13: Int;
  qty14: Int;
  qty15: Int;
  qty16: Int;
  qty17: Int;
  qty18: Int;
  qty19: Int;
  qty20: Int;
  qty21: Int;
  qty22: Int;
  qty23: Int;
  qty24: Int;
  qty25: Int;
  qty26: Int;
  qty27: Int;
  qty28: Int;
  qty29: Int;
  qty30: Int;
  qty31: Int;
  qty32: Int;
  itemWeight1: Float;
  itemWeight2: Float;
  itemWeight3: Float;
  itemWeight4: Float;
  itemWeight5: Float;
  itemWeight6: Float;
  itemWeight7: Float;
  itemWeight8: Float;
  itemWeight9: Float;
  itemWeight10: Float;
  itemWeight11: Float;
  itemWeight12: Float;
  itemWeight13: Float;
  itemWeight14: Float;
  itemWeight15: Float;
  itemWeight16: Float;
  itemWeight17: Float;
  itemWeight18: Float;
  itemWeight19: Float;
  itemWeight20: Float;
  itemWeight21: Float;
  itemWeight22: Float;
  itemWeight23: Float;
  itemWeight24: Float;
  itemWeight25: Float;
  itemWeight26: Float;
  itemWeight27: Float;
  itemWeight28: Float;
  itemWeight29: Float;
  itemWeight30: Float;
  itemWeight31: Float;
  itemWeight32: Float;
  price1: Float;
  price2: Float;
  price3: Float;
  price4: Float;
  price5: Float;
  price6: Float;
  price7: Float;
  price8: Float;
  price9: Float;
  price10: Float;
  price11: Float;
  price12: Float;
  price13: Float;
  price14: Float;
  price15: Float;
  price16: Float;
  price17: Float;
  price18: Float;
  price19: Float;
  price20: Float;
  price21: Float;
  price22: Float;
  price23: Float;
  price24: Float;
  price25: Float;
  price26: Float;
  price27: Float;
  price28: Float;
  price29: Float;
  price30: Float;
  price31: Float;
  price32: Float;
  weight1: Float;
  weight2: Float;
  weight3: Float;
  weight4: Float;
  weight5: Float;
  weight6: Float;
  weight7: Float;
  weight8: Float;
  weight9: Float;
  weight10: Float;
  weight11: Float;
  weight12: Float;
  weight13: Float;
  weight14: Float;
  weight15: Float;
  weight16: Float;
  weight17: Float;
  weight18: Float;
  weight19: Float;
  weight20: Float;
  weight21: Float;
  weight22: Float;
  weight23: Float;
  weight24: Float;
  weight25: Float;
  weight26: Float;
  weight27: Float;
  weight28: Float;
  weight29: Float;
  weight30: Float;
  weight31: Float;
  weight32: Float;
  totalItems: Float;
  totalWeight: Float;
  totalCost: Float;
}

export const gqlGetSumOfContributionsItem = gql`
  query getSumOfContributionsItem($contributorId: Int, $year: Int) {
    getSumOfContributionsItem(contributorId: $contributorId, year: $year) {
      data {
        fieldNumber
        version
        contributionbatteriesGroupId
        contributionbatteriesGroupName
        baseCategoryName
        categoryName
        typeName
        qty
        weight
        price
      }
      recordCount
    }
  }
`;

export const gqlGetYearlyContributionsPerContributor = gql`
  query getYearlyContributionsPerContributor($year: Int) {
    getYearlyContributionsPerContributor(year: $year) {
      data {
        contributorId
        contributorName
        vatNumber
        qty
        weight
        price
      }
      recordCount
    }
  }
`;
